import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../../Utils/authHelper';

/**
 * A wrapper component for routes that require authentication.
 * If the user is not logged in, it redirects to the Signin page.
 * It also preserves the current location so the user can be redirected back after login.
 */
const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const authenticated = isLoggedIn();

    if (!authenticated) {
        // Redirect to signin, but save the current location they were trying to access
        return <Navigate to="/signin" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
